// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';

import Button from 'app/common/ui/Button';

import styles from './MoreLink.scss';


type Props = {
  to: string,
  t: (string, string) => string,
}

const MoreLink = ({ to, t }: Props) => (
  <div className={styles.root}>
    <Button value={t('more_link', 'Подробнее')} href={to} outline />
  </div>
);

export default withTranslation('children')(MoreLink);
